import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { ZoomableImage } from 'components/common/ZoomableImage';

import { cn } from 'lib/utils';

function Avatar({
  className,
  ...props
}) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        'relative flex size-8 shrink-0 overflow-hidden rounded-full',
        className
      )}
      {...props} />);


}

function AvatarImage({
  className,
  zoomable = true,
  src,
  alt = '',
  ...props
}) {
  if (!zoomable || !src) {
    return (
      <AvatarPrimitive.Image
        data-slot="avatar-image"
        className={cn('aspect-square size-full', className)}
        src={src}
        alt={alt}
        {...props} />
    );
  }

  return (
    <AvatarPrimitive.Image asChild data-slot="avatar-image" {...props}>
      <ZoomableImage
        src={src}
        alt={alt}
        variant="lightbox"
        className={cn('aspect-square size-full object-cover', className)}
        containerClassName="size-full"
      />
    </AvatarPrimitive.Image>
  );
}

function AvatarFallback({
  className,
  ...props
}) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(
        'bg-muted flex size-full items-center justify-center rounded-full',
        className
      )}
      {...props} />);


}

export { Avatar, AvatarImage, AvatarFallback };